import axios from "axios";

export const COURSE_URL = "/Course";
export const GRADE_COURSE_URL = "/GradeCourse";
export const HOMEWORK_SOURCE_URL = "/HomeworkSource";

/** Mevcut Okula Ait Belli Bir Ödev Kaynak Listesini Elde Eder */
export function getHomeworkSources(queryParams) {
  return axios.post(`${HOMEWORK_SOURCE_URL}/GetHomeworkSources`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Ödev Kaynak Listesini Sayfalama Olmadan Elde Eder */
export function getAllHomeworkSources(queryParams) {
  return axios.post(`${HOMEWORK_SOURCE_URL}/GetAllHomeworkSources`, queryParams);
}

/** Mevcut Okula Ait Ders Listesini Elde Eder */
export function getCourses() {
  return axios.get(`${COURSE_URL}/GetCourses`);
}

/** Mevcut Okulun Belli Bir Sınıfına Ait Ders Listesini Elde Eder */
export function getGradeCourses(grade) {
  return axios.get(`${GRADE_COURSE_URL}/GetGradeCourses/${grade}`);
}

/** Yeni Bir Ödev Kaynağı Elde Eder */
export function getNewHomeworkSource() {
  return axios.get(HOMEWORK_SOURCE_URL);
}

/** Belli Bir Ödev Kaynağı Elde Eder */
export function getHomeworkSource(id) {
  return axios.get(`${HOMEWORK_SOURCE_URL}/${id}`);
}

/** Belli Bir Ödev Kaynağını Kaydeder */
export function saveHomeworkSource(source) {
  return axios.post(HOMEWORK_SOURCE_URL, source);
}

/** Belli Bir Ödev Kaynak Listesini Kaydeder */
export function saveHomeworkSources(datas) {
  return axios.post(`${HOMEWORK_SOURCE_URL}/Save`, { datas });
}

/** Belli Bir Ödev Kaynak Listesini Siler */
export function deleteHomeworkSources(ids) {
  return axios.post(`${HOMEWORK_SOURCE_URL}/Delete`, { ids });
}